// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from "./store";
import router from './router'
import vuetify from './plugins/vuetify'
import firebase from 'firebase';
import 'firebase/firestore';
import firebaseConfig from '@/firebase/firebase';
firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  store,
  components: { App },
  template: '<App/>',
  mounted() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        db.collection('users').doc(user.uid).onSnapshot(snapshot => {
          // if (user.emailVerified) {
            store.commit('setUser', user);
            if (snapshot.exists) {
              this.$store.commit("setRole", snapshot.data().role);
              this.$store.commit('setName', snapshot.data().name);
              this.$store.commit('setImg', snapshot.data().imgUrl);
              this.$store.commit('setPhone', snapshot.data().phone);
              this.$store.commit('setLastName', snapshot.data().lastName);
            }
            store.commit('setLoaded', true);
          // }
        })
      } else {
        store.commit('setLoaded', true);
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js